import { render, staticRenderFns } from "./expo-inquiry-list.vue?vue&type=template&id=4c7d22d6&scoped=true"
import script from "./expo-inquiry-list.vue?vue&type=script&lang=js"
export * from "./expo-inquiry-list.vue?vue&type=script&lang=js"
import style0 from "./expo-inquiry-list.vue?vue&type=style&index=0&id=4c7d22d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d22d6",
  null
  
)

export default component.exports